import { PageLayout } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';

import { AccountLayoutResolver } from './AccountLayoutResolver';

export const AccountOutlet: React.FC = () => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return <AccountLayoutResolver />;
  }

  return (
    <PageLayout titleContent="My Account" paperSx={{ mt: 5 }}>
      <AccountLayoutResolver />
    </PageLayout>
  );
};
